import { Link } from 'react-router-dom';
import { useCookieConsent } from '../global/cookieConsent';

const CookieBanner = () => {
    const { consent, chooseConsent } = useCookieConsent();
    if (consent) return null;

    return (
        <section
            aria-label="Choix des cookies"
            aria-live="polite"
            className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-4xl rounded-xl border border-gray-200 bg-white p-5 shadow-2xl sm:bottom-6 sm:p-6"
        >
            <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
                <div className="max-w-2xl">
                    <h2 className="text-lg font-semibold text-gray-900">Votre choix concernant les cookies</h2>
                    <p className="mt-2 text-sm leading-6 text-gray-600">
                        Les technologies nécessaires assurent le fonctionnement et la sécurité du site. Avec votre accord,
                        nous utilisons aussi Google Analytics et chargeons certains contenus externes afin de mesurer
                        l’audience et d’améliorer votre expérience.
                    </p>
                    <Link className="mt-2 inline-block text-sm font-medium text-primary underline" to="/politique-de-confidentialite">
                        Consulter la politique de confidentialité
                    </Link>
                </div>
                <div className="flex shrink-0 flex-col gap-2 sm:flex-row md:flex-col">
                    <button
                        type="button"
                        onClick={() => chooseConsent('accepted')}
                        className="rounded-md bg-primary px-5 py-2.5 text-sm font-medium text-white hover:opacity-90"
                    >
                        Accepter
                    </button>
                    <button
                        type="button"
                        onClick={() => chooseConsent('refused')}
                        className="rounded-md border border-primary px-5 py-2.5 text-sm font-medium text-primary hover:bg-green-50"
                    >
                        Refuser
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CookieBanner;
